<template>
  <section class="vbox">
    <section class="scrollable wrapper">
      <div class="content-header">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>店铺</el-breadcrumb-item>
          <el-breadcrumb-item>商品</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="content-main">
        <el-form :inline="true" size="medium">
          <el-form-item>
            <el-button type="primary" class="el-icon-circle-plus-outline" v-on:click="Add" >新增</el-button>
          </el-form-item>                  
          <el-form-item >
            <el-input  placeholder="商品编码" v-model="queryParam.barcode"  size="small" clearable></el-input>
          </el-form-item>
          <el-form-item >
            <el-input  placeholder="商品名称" v-model="queryParam.name"  size="small" clearable></el-input>
          </el-form-item>
          <el-form-item >
            <el-input  placeholder="所属商家" v-model="queryParam.merchantName"  size="small" clearable></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" v-on:click="Search" >查询</el-button>
          </el-form-item>
        </el-form>
        <el-table 
          :data="products" 
          stripe
          style="width: 100%"
          >
          <el-table-column  prop="Barcode" width="100px" fixed="left" label="编码"> </el-table-column>
          <el-table-column  prop="Icon" label="图标" width="80" align="center">
            <template slot-scope="scope">
              <el-popover
                v-if="scope.row.Icon"
                placement="left"
                trigger="hover"
              >
                <div>
                  <img
                    :src="scope.row.Icon"
                    width="400px"
                  >
                </div>  
                <img
                  slot="reference"
                  :src="scope.row.Icon"
                  width="20"
                  height="20"
                >
              </el-popover> 
              <p v-else>
                --
              </p>
            </template>         
          </el-table-column> 
          <el-table-column  prop="Name"  label="名称" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column  prop="OriginalPrice" label="原价"> </el-table-column>
          <el-table-column  prop="Price" label="售价"> </el-table-column>
          <el-table-column  prop="MerchantName" :show-overflow-tooltip="true" label="所属商家"> </el-table-column>
          <el-table-column  prop="CategoryName"  label="类别"> </el-table-column>
          <el-table-column  prop="Score"  label="评分"> </el-table-column>
          <el-table-column  prop="SaleCount"  label="已售数量"> </el-table-column>
          <el-table-column  prop="MallDisplay"  label="商城展示" > 
            <template slot-scope="scope">                    
              <p v-if="scope.row.MallDisplay==true">展示</p>
              <p v-if="scope.row.MallDisplay==false">不展示</p>         
            </template>
          </el-table-column>
          <el-table-column  prop="StoreDisplay"  label="门店展示" > 
            <template slot-scope="scope">                    
              <p v-if="scope.row.StoreDisplay==true">展示</p>
              <p v-if="scope.row.StoreDisplay==false">不展示</p>         
            </template>
          </el-table-column>
          <el-table-column  prop="Sort"  label="排序" ></el-table-column>
          <el-table-column  fixed="right" label="操作" width="120">
            <template slot-scope="scope">
              <el-button @click.native.prevent="Edit(scope.row.Id)" type="text" size="small">
                编辑
              </el-button>
              <el-button @click.native.prevent="deleteRow(scope.row.Id)" type="text" size="small">
                删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          :hide-on-single-page="true"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="queryParam.pageIndex"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="queryParam.pagesize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="queryParam.totalCount">
        </el-pagination>
      </div>   
    </section>
  </section>
</template>
<script  type='text/ecmascript-6'>
  export default {
    props:{
    },
    data (){
      return {
        products:[],
        queryParam:{
          barcode:'',
          name:'',
          merchantName:'',
          pageIndex:1,
          pagesize:10,
          sort:' id desc ',
          totalCount:10,
        }
      }
    },
    computed:{
    },
    mounted(){
      if (this.$route.params.queryParam) {
        this.queryParam = this.$route.params.queryParam
      }
      this.GetData();
    },
    methods:{     
      Search:function(){
        this.queryParam.pageIndex = 1;
        this.GetData();
      },
      Add:function(){
        this.$router.push({
          name:'productInfo',
          params:{
            Id:''
          }
        })
      },
      GetData:function(){
        var that = this
        this.axios({
          method:'get',
          url: that.global.serverSrc + '/api/Product/Index',
          params: that.queryParam
        }).then(function (resp) {
          that.queryParam.totalCount = resp.data.totalCount
          that.products = resp.data.products
        }).catch(resp => {
          console.log('请求失败：' + resp.message + ',' + resp.stack)
        })
      },
      Edit(id){
        this.$router.push({
          name:'productInfo',
          params:{
            Id:id,
            queryParam: this.queryParam
          }
        })
      },
      deleteRow(id) {
        this.$confirm('确定要删除该产品吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          var that = this
          this.axios({
            method:'post',
            url:that.global.serverSrc + '/api/Product/Delete',
            data:{
              id: id
            }
          }).then(function (resp) {  
            if(resp.data.errorCode==0){              
              that.$message.success(resp.data.message);
              that.GetData();
            }else {              
              that.$message.warning(resp.data.message);
            }
          }).catch(resp => {
            console.log('请求失败：' + resp.message + ',' + resp.stack)
          })
        }).catch(() => {
            
        });
      },
      handleSizeChange(val) {
        this.queryParam.pagesize = val
        this.queryParam.pageIndex = 1
        this.GetData()
      },
      handleCurrentChange(val) {
        this.queryParam.pageIndex = val 
        this.GetData()
      }
    },
    components:{    
       
    },
    created(){
    
    },
  }
</script>
<style lang='stylus' rel='stylesheet/stylus'>
.content-header
  padding 24px
  border 1px solid #C0C4CC
.content-main
  padding 24px  
</style>